import React, { useState } from 'react';

import { RowButton } from '@eika/button';
import { Icon, IconTypes } from '@eika/icon';

import type { Currency } from '../../../generated-types';
import useTranslation from '../../../hooks/useTranslation';
import { EikaModal } from '../../EikaModal';
import TransferCurrency from './TransferCurrency';

import './CurrencyField.scss';

interface Props {
    transferCurrency?: Currency;
    label: string;
    onChange: (value: Currency) => void;
    onShow?: (show: boolean) => void;
}

const TransferCurrencyField: React.FC<Props> = ({ transferCurrency, label, onChange, onShow }) => {
    const translated = useTranslation();
    const [showModal, setShowModal] = useState(false);

    const openModal = (show: boolean) => {
        setShowModal(show);
        onShow?.(show);
    };

    return (
        <>
            <RowButton onClick={() => openModal(true)}>
                <div className="currency-field__layout">
                    <div className="currency-field__label">
                        <span className="currency-field__label">{label}</span>
                        <span className="currency-field__value">{String(transferCurrency) ?? ''}</span>
                    </div>
                    <div className="currency-field__icon">
                        <Icon
                            type={IconTypes.LITEN_PIL_HOEYRE}
                            className="icon--20"
                            ariaLabel="Endre øverføringsvaluta"
                        />
                    </div>
                </div>
            </RowButton>
            <EikaModal
                id="transferCurrencyField"
                className="transfer-currency-field"
                open={showModal}
                setOpen={openModal}
                title={translated.currencyField.title}
            >
                <p className="transfer-currency__description">{translated.currencyField.transferCurrencyDescription}</p>
                <h3 className="transfer-currency__choose-currency-title">
                    {translated.currencyField.transferCurrencySubTitle}
                </h3>
                <TransferCurrency onChange={onChange} setOpen={openModal} />
            </EikaModal>
        </>
    );
};

export default TransferCurrencyField;
